import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

interface Payload {
  geofence: uui.domain.client.gps.wwgps.Geofence
  bounds: uui.domain.LatLngBounds
}

/**
 * Update a single geofence
 *
 * @private
 */
export const updateGeofence = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/geofence/update', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/geofence/update', {
      category: 'rpc',
      type: 'rpc/geofence/update',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateGeofence}`,
      { tags: ['rpc', 'geofence'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update geofence failed`,
      error,
    })
  }
})
